import { render } from "./phone-login.vue?vue&type=template&id=90374b3e&scoped=true&ts=true"
import script from "./phone-login.vue?vue&type=script&lang=ts"
export * from "./phone-login.vue?vue&type=script&lang=ts"

import "./phone-login.vue?vue&type=style&index=0&id=90374b3e&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90374b3e"]])